import styled from 'styled-components'

export const Container = styled.div`
	.timeline::before {
		content: '';
		position: absolute;
		top: 50%;
		left: 0;
		right: 0;
		height: 0.5px;
		background-color: #eee;
		transform: translateY(-50%);
		z-index: 1;
		width: 100%;
	}

	padding-bottom: 2rem;
`
